import React, { Button } from '../../ds';
import { ReactComponent as Icon } from './logout-icon.svg';
import Auth from '../../Utils/Auth/auth';
import AnalyticsEvent from '../../services/analytics/AnalyticsEvent';
import { getHostAppUrl } from '../../Utils/environment';
import { isFeatureEnabled } from '../../Utils/Feature/feature_flag';
import Requestor from '../../Utils/fetchHTTP/Requestor';
import { useQueryClient } from '@tanstack/react-query';

async function cleanLocalStorage() {
  try {
    await Auth.logout();

    await Requestor().getRequest({
      method: 'POST',
      url: `${getHostAppUrl()}/api/auth/signout`,
      extraOptions: {
        disableBaseUrl: true,
      },
    });
  } catch (error) {
    console.log(error);
    localStorage.clear();
    AnalyticsEvent().errorTrack({
      errorType: 'clean-local-storage-error',
      errorDescription: error,
    });
  } finally {
    window.location.replace(
      isFeatureEnabled('enabled_new_portal_urls')
        ? `${getHostAppUrl()}/login`
        : '/login'
    );
  }
}

function LogoutIcon() {
  const queryClient = useQueryClient();

  const handleLogOut = async () => {
    try {
      await Auth.logout();
      await Requestor().getRequest({
        method: 'POST',
        url: `${getHostAppUrl()}/api/auth/signout`,
        extraOptions: {
          disableBaseUrl: true,
        },
      });
      queryClient.removeQueries();
    } catch (error) {
      console.log(error);
      AnalyticsEvent().errorTrack({
        errorType: 'logout-error',
        errorDescription: error,
      });
    } finally {
      window.location.replace(
        isFeatureEnabled('enabled_new_portal_urls')
          ? `${getHostAppUrl()}/login`
          : '/login'
      );
    }
  };

  return (
    <Button
      type='simple'
      size='small'
      horizontalPadding='0'
      onClick={handleLogOut}
    >
      <Icon />
      <span className='k-ds-m-left-sp-06'>Cerrar sesión</span>
    </Button>
  );
}
export default LogoutIcon;

export { cleanLocalStorage };
